import common from '../common';
import Scene from './Scene';
import {
	translate, Text
} from '../utils';

export default class PreloaderScene extends Scene {
	constructor() {
		super();

		this.loaded = 0;

		this._loadMask = null;
		this._fillContainer = new PIXI.Container();
		this.signals.mobileLoad = new P3.utils.MiniSignal();
	}

	init() {
		super.init();

		let bg = new PIXI.Sprite(P3.assets.texture('bg_preloader'));
		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(bg);

		let tomOutline = new PIXI.Sprite(P3.assets.texture('outline_tom'));
		tomOutline.anchor.set(0.5);
		tomOutline.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(tomOutline);

		let jerryOutline = new PIXI.Sprite(P3.assets.texture('outline_jerry'));
		jerryOutline.anchor.set(0.5);
		jerryOutline.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this.addChild(jerryOutline);

		let tomFill = new PIXI.Sprite(P3.assets.texture('fill_tom'));
		tomFill.anchor.set(0.5);
		tomFill.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._fillContainer.addChild(tomFill);

		let jerryFill = new PIXI.Sprite(P3.assets.texture('fill_jerry'));
		jerryFill.anchor.set(0.5);
		jerryFill.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._fillContainer.addChild(jerryFill);

		this._loadMask = new PIXI.Graphics();
		this._loadMask.beginFill(0xFF0000);
		this._loadMask.drawRect(
			0,
			0,
			common.STAGE_WIDTH,
			common.STAGE_HEIGHT
		);
		this._fillContainer.mask = this._loadMask;
		this._loadMask.y = common.STAGE_HEIGHT;
		this.addChild(this._fillContainer);
		this.addChild(this._loadMask);

		if (common.config.language === 'ar') {
			let loadingText = new PIXI.Sprite(P3.assets.texture('loading_ar'));
			loadingText.anchor.set(0.5);
			loadingText.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.1);
			this.addChild(loadingText);
		} else {
			let loadingText = new Text(translate('loading'), {fontSize: 30, fontFamily: 'Ed', align: 'center'});
			loadingText.anchor.set(0.5);
			loadingText.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.1);
			this.addChild(loadingText);
		}
	}

	resize() {
		super.resize();
	}

	destroy() {
		// clean up goes here
		super.destroy();
	}

	update() {
		this._loadMask.scale.y = this.loaded * -1;
	}
}
